export default "__VITE_ASSET__BWEJN7O0__"